import { FC, useMemo } from 'react'
import { ButtonTransformer } from 'src/relay/Transformers/ButtonTransormer'
import ActionGrid, { ActionGridProps } from 'src/components/ActionGrid'
import Router from 'src/routes/Router'
import routes from 'src/routes/definitions'
import { ImageTransformer } from 'src/relay/Transformers/ImageTransformer'
import { RichTextTransformer } from 'src/relay/Transformers/RichTextTransformer'

import { BlockProps } from '../props'

import { RemonteeProjetsProps } from './props'

const RemonteeProjets: FC<BlockProps<RemonteeProjetsProps>> = ({
  data,
  locale,
  configuration,
}) => {
  const props: ActionGridProps = useMemo(
    () => ({
      ...(data.title && {
        blockTitleProps: {
          title: data.title,
          ...(data.description && {
            richTextProps: RichTextTransformer(
              data.description,
              configuration,
              locale
            ),
          }),
          actionButtonProps: ButtonTransformer({ data: data.cta }),
        },
      }),
      actions:
        // Strapi v4 wraps relation collections as `{ data: [{ attributes }] }`;
        // v5 returns a flat array. Unwrap at both levels.
        ((data.projets as any)?.data ?? data.projets ?? []).map(
          (projectRaw: any) => {
            const attrs: any = projectRaw?.attributes ?? projectRaw
            const desktopImage =
              attrs?.hero?.desktopImage?.data ?? attrs?.hero?.desktopImage
            const mobileImage =
              attrs?.hero?.mobileImage?.data ?? attrs?.hero?.mobileImage
            const imageProps = ImageTransformer(desktopImage, {
              desktop: '100vw',
              big: '50vw, 33vw',
            })
            const mobileImageProps = ImageTransformer(mobileImage, {
              desktop: '100vw',
              big: '50vw, 33vw',
            })
            return {
              ...(imageProps && {
                pictureProps: {
                  imageProps,
                  ...(mobileImageProps && { mobileImageProps }),
                },
              }),
              forcedRatio: 0.75,
              linkProps: {
                text: attrs?.hero?.title || '',
                href: Router.getRouteUrl(routes.projects, {
                  slug: attrs?.slug || '',
                  lang: locale,
                }),
                locale,
              },
            }
          }
        ),
    }),
    [configuration, data, locale]
  )

  return <ActionGrid {...props} />
}

export default RemonteeProjets
